import { StudentSession } from "@axl-dev/school-sdk";
import { Button, Space, Statistic } from "antd";
import cn from "classnames";
import moment from "moment";

import {
  useAuth,
  useLoc,
  useSdk,
  useTokenStorage,
} from "@app/shared/lib/hooks";

import { Header } from "../Header";

import styles from "./AdminMark.module.scss";

type Props = {
  session: StudentSession;
};

export const AdminMark: React.FC<Props> = ({ session }) => {
  const loc = useLoc();
  const { logout } = useAuth();
  const sdk = useSdk();
  const tokenStorage = useTokenStorage();

  return (
    <Header.Item>
      <div className={cn(styles.container, "flex flex-col lh-15")}>
        <span className="fw-500">
          {loc.word("You are logged in as an student", {
            default: "You are logged in as an student",
          })}
        </span>
        {session.expiredDate != null && (
          <Space size="small">
            {loc.word("Until the end of the session left")}
            <Statistic.Countdown
              valueStyle={{ fontSize: 14 }}
              value={moment(session.expiredDate!).valueOf()}
              format="HH:mm:ss"
              onFinish={() => logout()}
            />
            <Button
              size="small"
              type="link"
              className="p-0"
              onClick={async () => {
                if (!tokenStorage.refreshToken) return;
                const result = await sdk.api.auth.prolongSession(
                  tokenStorage.refreshToken,
                );
                if (!result.success) logout();
              }}
            >
              {loc.word("Update", { default: "Update", case: "lower" })}
            </Button>
          </Space>
        )}
      </div>
    </Header.Item>
  );
};
